import React, { useContext, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Fade from '@material-ui/core/Fade';
import { usePrefersReducedMotion } from '@chakra-ui/react';
import { useAnimationToggle } from '../../../Contexts/AnimationContext';
import SliderHeader, { SliderHeaderContext } from './SliderHeader';
import './Slider.css';

// Keep legacy slide/index props for callers; only page content changes opacity.
export default function Slider({ slide, index, onClick, name, contentTitle, children,
   toggle, canGoBack = true, preserveHeader = false }) {
   const shell = useContext(SliderHeaderContext);
   const animationPreference = useAnimationToggle();
   const prefersReducedMotion = usePrefersReducedMotion();
   const transitionDuration = animationPreference?.animationsEnabled === false || prefersReducedMotion ? 0 : 160;
   useLayoutEffect(() => {
      if (shell && slide) shell.updateHeader({ name, index, onClick, canGoBack }, preserveHeader);
   }, [shell, slide, name, index, onClick, canGoBack, preserveHeader]);

   const content = (
      <Fade in={slide} timeout={transitionDuration} mountOnEnter unmountOnExit>
            <div className="SliderContentContainer">
               {contentTitle && <h2 className="contentTitle">{contentTitle}</h2>}
               {React.Children.map(children, (child) =>
                  React.isValidElement(child) ? React.cloneElement(child, {
                     toggle
                  }) : child
               )}
            </div>
      </Fade>
   );
   if (shell) return content;
   if (!slide) return null;
   return <div className="Slider" style={{ top: `${3 * index}em`, height: `calc(100% - ${3 * index}em)` }}>
      {slide && <SliderHeader name={name} index={index} onClick={onClick} canGoBack={canGoBack} />}
      {content}
   </div>;
}

Slider.propTypes = {
   slide: PropTypes.bool,
   index: PropTypes.number,
   onClick: PropTypes.func,
   name: PropTypes.string,
   contentTitle: PropTypes.string,
   children: PropTypes.node,
   canGoBack: PropTypes.bool,
   preserveHeader: PropTypes.bool,
   toggle: PropTypes.any
};
